import { Konnexsparte } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicSelectModel, DynamicSelectModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_ABSCHLUSS = 'ABSCHLUSS';

export interface AbschlussModelConfig extends DynamicSelectModelConfig<Konnexsparte> {
  icon?: string;
  heading?: string;
  content: string;
  contentValues: Record<string, string>;
}

export class AbschlussComponentModel extends DynamicSelectModel<Konnexsparte> {
  @serializable() readonly type: string = TYPE_ABSCHLUSS;

  @serializable() icon: string;
  @serializable() heading: string;
  @serializable() content: string;
  @serializable() contentValues: Record<string, string>;

  constructor(config: AbschlussModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.icon = config.icon || null;
    this.heading = config.heading || null;
    this.content = config.content || null;
    this.contentValues = config.contentValues || null;
  }
}
